import { useCallback } from "react";
import { getCssVarValue, oklchToRgb } from "../utils/index.js";
const colorCache = new Map();
const useOklchToRgb = ()=>{
    const convertCssVarToRgb = useCallback((cssVarName)=>{
        if (!cssVarName.startsWith('--')) cssVarName = `--${cssVarName}`;
        if (colorCache.has(cssVarName)) return colorCache.get(cssVarName);
        const oklchValue = getCssVarValue(cssVarName);
        const rgbValue = oklchToRgb(oklchValue);
        colorCache.set(cssVarName, rgbValue);
        return rgbValue;
    }, []);
    const convertMultipleVars = useCallback((cssVarNames)=>cssVarNames.map((varName)=>convertCssVarToRgb(varName)), [
        convertCssVarToRgb
    ]);
    const clearCache = useCallback(()=>{
        colorCache.clear();
    }, []);
    const refreshCachedValue = useCallback((cssVarName)=>{
        if (!cssVarName.startsWith('--')) cssVarName = `--${cssVarName}`;
        colorCache.delete(cssVarName);
        return convertCssVarToRgb(cssVarName);
    }, [
        convertCssVarToRgb
    ]);
    return {
        convertCssVarToRgb,
        convertMultipleVars,
        clearCache,
        refreshCachedValue
    };
};
export { useOklchToRgb };
